import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import { map } from 'lodash';

import CallItem from './CallItem';

let CallItems = ({ calls, translate, }) => {
  const callsList =  map(calls, (call, key) => {

      return <CallItem call={call} key={key}/>
    })
  if (callsList.length < 1) {
    return(
      <div className="table-container" id="MyServices">
        <div className="center font-weight-bold text-primary">
          {translate('no-results')}
        </div>
      </div>
    )  }
  return(
    <div  className="table-container">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>{translate('call-date')}</th>
            <th>{translate('call-time')}</th>
            <th>{translate('calling-number')}</th>
            <th>{translate('called-number')}</th>
            <th>{translate('call-duration')}</th>
            <th>{translate('call-price-excluding-tax')}</th>
            <th>{translate('destination')}</th>
          </tr>
        </thead>
        <tbody>
        {callsList}
        </tbody>
      </table>
    </div>
  )
}
const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setInvoices: (invoices) => {
      dispatch(
        {
          type: 'SET_INVOICES',
          invoices: invoices,
        },
      );
    },
  }
}

CallItems = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(CallItems);

export default CallItems;



// WEBPACK FOOTER //
// ./src/components/CallDetails/CallItems.js